import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const ManagerRound = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.MANAGER_ROUND} />
}

export default ManagerRound;